import styled from "styled-components";

const Span = styled.span`
  display: block;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 2px;

  @media (max-width: 575px) {
    font-size: 13px;
  }
`;
export default Span;
